import { useState, useCallback } from 'react';
import {
    Button, Table,
} from 'reactstrap';
import { v7 as uuid } from 'uuid';
import { isEmpty } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import { NumericInput } from '../common/forms/NumericInput';
import { SmallButton } from '../common/forms/FormElements';
import { Modal } from '../common/Modal';

export const USCountyGroupBumpRuleGrid = ({
    bumpRules,
    usCountyGroups,
    onBumpRulesChange,
}) => {
    const [editing, setEditing] = useState([]);

    const handleSubmit = useCallback((newBumpRule) => {
        const updatedBumpRules = [...bumpRules, newBumpRule];
        onBumpRulesChange(updatedBumpRules);
    }, [bumpRules, onBumpRulesChange]);

    const handleEditBumpRuleButtonClick = useCallback((id) => {
        setEditing([...editing, id]);
    }, [editing]);

    const handleRemoveBumpRuleButtonClick = useCallback((id) => {
        const updated = bumpRules.filter((rule) => rule.id !== id);

        onBumpRulesChange(updated);
    }, [bumpRules, onBumpRulesChange]);

    const handleUpdateBumpRule = useCallback((id, field, value) => {
        const updated = [...bumpRules];
        const index = updated.findIndex((rule) => rule.id === id);

        updated[index][field] = value;

        onBumpRulesChange(updated);
    }, [onBumpRulesChange, bumpRules]);

    const handleAddBumpRuleButtonClick = useCallback(() => {
        Modal.show({
            title: 'Add Bump Rule',
            onSubmit: handleSubmit,
            initialValues: {
                id: uuid(),
            },
            body: () => (
                <>
                    <NumericInput
                        id="bumpHours"
                        name="bumpHours"
                        label="Hours to bump to"
                        min={0}
                        step={0.5}
                        required
                        error="Please enter a number for this bump rule"
                    />

                    <ValidatedSelect
                        id="homeUSCountyGroups"
                        name="homeUSCountyGroups"
                        label="Applies only to workers from (optional)"
                        options={usCountyGroups}
                        valueField="id"
                        asPrimitive
                        getOptionLabel={(option) => option.description}
                        getOptionValue={(option) => option.id}
                        isClearable
                        isMulti
                        error="Select a home local or leave empty."
                    />
                </>
            ),
        });
    }, [handleSubmit, usCountyGroups]);

    return (
        <div>
            <div className="d-flex justify-content-end mb-1">
                <SmallButton
                    type="button"
                    onClick={handleAddBumpRuleButtonClick}
                >
                    <FontAwesomeIcon
                        icon={faPlusCircle}
                        size="md"
                        className="mr-2"
                    />
                    Add Bump Rule
                </SmallButton>
            </div>

            <Table
                className="table table-sm"
                bordered
                responsive
            >
                <thead>
                    <tr>
                        <th># Hours</th>
                        <th>
                            Applies to Workers From
                        </th>
                        <th className="text-center">
                            <FontAwesomeIcon icon={faEdit} />
                        </th>
                        <th className="text-center">
                            <FontAwesomeIcon icon={faTrash} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {isEmpty(bumpRules) ? (
                        <tr>
                            <td
                                colSpan={5}
                                className="text-center"
                            >
                                No bump rules found
                            </td>
                        </tr>
                    ) : (
                        bumpRules.map((bumpRule) => {
                            let groupLabel = 'All locals';

                            if (bumpRule.homeUSCountyGroups?.length > 0) {
                                groupLabel = bumpRule.homeUSCountyGroups.map((groupId) => usCountyGroups.find((group) => group.id === groupId)?.description).filter((x) => x).join(', ');
                            }

                            return (
                                <tr key={bumpRule.id}>
                                    {editing.includes(bumpRule.id) ? (
                                        <td>
                                            <NumericInput
                                                className="text-right"
                                                name="bumpHours"
                                                required
                                                value={bumpRule.bumpHours}
                                                onChange={(e) =>
                                                    handleUpdateBumpRule(bumpRule.id, 'bumpHours', parseFloat(e.target.value))
                                                }
                                                min={0}
                                                step={0.5}
                                            />
                                        </td>
                                    ) : (
                                        <td>
                                            {bumpRule.bumpHours}

                                            {' '}

                                            hrs
                                        </td>
                                    )}

                                    <td>
                                        {groupLabel}
                                    </td>

                                    <td
                                        className="text-center"
                                        style={{ width: '30px' }}
                                    >
                                        <Button
                                            type="button"
                                            color="outline-primary"
                                            size="sm"
                                            onClick={() => handleEditBumpRuleButtonClick(bumpRule.id)}
                                        >
                                            Edit
                                        </Button>
                                    </td>
                                    <td
                                        className="text-center"
                                        style={{ width: '30px' }}
                                    >
                                        <Button
                                            type="button"
                                            color="outline-primary"
                                            onClick={() => handleRemoveBumpRuleButtonClick(bumpRule.id)}
                                            size="sm"
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </Button>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
        </div>
    );
};
